<div class="report-view" *ngIf="partitions && simulations">
    <aside class="side-block">
        <h2>
            {{'reports.custom.tree.shortLabel' | translate}}
            <app-tooltip text="{{'reports.custom.tree.summary' | translate}}"></app-tooltip>
        </h2>
        <app-partitions-tree class="tree" id="tree-block" [isMultiple]="true" [partitions]="partitions"
            (toggleSelection)="onSelectPartition($event)"></app-partitions-tree>
    </aside>
    <section class="main-block" *ngIf="isReportReady">
        <div *ngFor="let reportItem of customReport.reportItems; index as i" id="custom-{{ reportItem.group }}-{{i}}">
            <!-- <app-report-chart id="custom-{{ reportItem.group }}-{{i}}" [reportItem]="reportItem"></app-report-chart> -->
            <app-report-variation-select [reportItem]="reportItem"></app-report-variation-select>
        </div>
    </section>
</div>
<mat-progress-bar *ngIf="!simulations" class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
